import {
	Modal
}from "antd"
import "antd/lib/modal/style/index.css"

const message = () => {
	Modal.confirm({
		title             : "Ошибка аутентификации",
		content           : "Время сессии истекло. Пожалуйста, повторите вход в личный кабинет.",
		cancelButtonProps : { style: { display: "none" } },
		maskClosable      : false,
		centered          : true,
		onOk              : () => {
			const iframe = document.getElementById("iframe")
			iframe.contentWindow.postMessage({
				action: 'clearToken'
			}, "*")
			window.localStorage.removeItem("user")
			window.localStorage.removeItem("lastActiveTab")
			window.location.href = "/"
		}
	})
}

export default message
